import { CountryDto } from "@cradua/data";
import { createAction, props } from "@ngrx/store";

/**
 * Load Stakeholder Reference Collection Actions
 */
export const loadStakeholderReference = createAction(
  "[StakeholderReference] Load Stakeholder Reference",
);

export const loadStakeholderReferenceSuccess = createAction(
  "[StakeholderReference] Load Stakeholder Reference Success",
  props<{ stakeholderreference: any[] }>(),
);

export const loadStakeholderReferenceFailure = createAction(
  "[StakeholderReference] Load Stakeholder Reference Failure",
  props<{ error: any }>(),
);

export const loadByTypeStakeholderReference = createAction(
  "[StakeholderReference] Load Stakeholder Reference",
  props<{ reftype: string; countryId: string; stakeholdergroupId: string }>(),
);

export const loadByTypeStakeholderReferenceSuccess = createAction(
  "[StakeholderReference] Load Stakeholder Reference Success",
  props<{ stakeholderreference: any[] }>(),
);

export const loadByTypeStakeholderReferenceFailure = createAction(
  "[StakeholderReference] Load Stakeholder Reference Failure",
  props<{ error: any }>(),
);

export const loadByTypeStakeholderReferenceGroup = createAction(
  "[StakeholderReferenceGroup] Load Stakeholder Reference Group",
  props<{ reftype: string; countryId: string; stakeholdergroupId: string }>(),
);

export const loadByTypeStakeholderReferenceGroupSuccess = createAction(
  "[StakeholderReferenceGroup] Load Stakeholder Reference Group Success",
  props<{ stakeholderreferencegroup: any[] }>(),
);

export const loadByTypeStakeholderReferenceGroupFailure = createAction(
  "[StakeholderReferenceGroup] Load Stakeholder Reference Group Failure",
  props<{ error: any }>(),
);

/**
 * Add Stakeholder Reference to Collection Actions
 */
export const addStakeholderReference = createAction(
  "[StakeholderReference] Add Stakeholder Reference",
  props<{ newStakeholderReference: any[]; reftype: string }>(),
);

export const addStakeholderReferenceSuccess = createAction(
  "[StakeholderReference] Add Stakeholder Reference Success",
  props<{ newStakeholderReference: any[] }>(),
);

export const addStakeholderReferenceFailure = createAction(
  "[StakeholderReference] Add Stakeholder Reference Failure",
  props<{ error: any }>(),
);

/**
 * Update Stakeholder Reference Collection Actions
 */
export const updateStakeholderReference = createAction(
  "[StakeholderReference] Update Stakeholder Reference",
  props<{ updateStakeholderReference: any[]; reftype: string }>(),
);

export const updateStakeholderReferenceSuccess = createAction(
  "[StakeholderReference] Update Stakeholder Reference Success",
  props<{ updateStakeholderReference: any[] }>(),
);

export const updateStakeholderReferenceFailure = createAction(
  "[StakeholderReference] Update Stakeholder Reference Failure",
  props<{ error: any }>(),
);

/**
 * Remove Country Collection Actions
 */
export const removeStakeholderReference = createAction(
  "[StakeholderReference] Remove Stakeholder Reference",
  props<{ ids: string[]; reftype: string }>(),
);

export const removeStakeholderReferenceSuccess = createAction(
  "[StakeholderReference] Remove Stakeholder Reference Success",
  props<{ ids: string[] }>(),
);

export const removeStakeholderReferenceFailure = createAction(
  "[StakeholderReference] Remove Stakeholder Reference Failure",
  props<{ error: any }>(),
);
